import {
  type DynamicClient,
  type WalletProviderMetadata,
} from '@dynamic-labs-sdk/client';
import {
  DYNAMIC_ICONIC_SPRITE_URL,
  formatWalletProviderGroupKey,
  formatWalletProviderKey,
} from '@dynamic-labs-sdk/client/core';

import type { BitcoinWalletProvider } from '../../../../BitcoinWalletProvider.types';
import type { UnisatInjectedProvider } from '../../unisat/UnisatInjectedProvider.types';
import { createUnisatWalletProvider } from '../../unisat/createUnisatWalletProvider';

export const BITGET_METADATA: WalletProviderMetadata = {
  displayName: 'Bitget Wallet',
  icon: `${DYNAMIC_ICONIC_SPRITE_URL}#bitgetwallet`,
};

type CreateBitgetBitcoinWalletProviderParams = {
  dynamicClient: DynamicClient;
  injectedProvider: UnisatInjectedProvider;
};

// The Bitget provider interface is the same as Unisat provider interface
// https://docs.bitkeep.com/en/docs/guide/wallet/btc.html
export const createBitgetBitcoinWalletProvider = ({
  dynamicClient,
  injectedProvider,
}: CreateBitgetBitcoinWalletProviderParams): BitcoinWalletProvider => {
  const unisatWalletProvider = createUnisatWalletProvider({
    dynamicClient,
    injectedProvider,
  });

  return {
    ...unisatWalletProvider,
    groupKey: formatWalletProviderGroupKey(BITGET_METADATA.displayName),
    key: formatWalletProviderKey({
      chain: unisatWalletProvider.chain,
      displayName: BITGET_METADATA.displayName,
      walletProviderType: unisatWalletProvider.walletProviderType,
    }),
    metadata: BITGET_METADATA,
  };
};
